import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const LetterWithArrowRightIcon = createIcon({
  displayName: 'LetterWithArrowRightIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M20,6.039v6.989" />
        <path d="M21,19.028h-6" />
        <path d="M19,17.028l2,2l-2,2" />
        <path d="M11,17.028h-6c-1.105,0 -2,-0.895 -2,-2v-8.989" />
        <path d="M5.011,4.028h12.979c1.11,0 2.011,0.9 2.011,2.011v0c0,0.667 -0.331,1.29 -0.883,1.664l-5.357,3.631c-1.365,0.925 -3.157,0.925 -4.522,0l-5.356,-3.63c-0.552,-0.374 -0.883,-0.998 -0.883,-1.664v-0.001c0,-1.111 0.9,-2.011 2.011,-2.011Z" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M24,0.028h-24v24h24v-24Z" />
    </>
  ),
})

const LetterWithArrowRight: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={LetterWithArrowRightIcon} {...props} />
}

export default memo(LetterWithArrowRight)
